export const clientOrganizations = Object.freeze([
  {
    clientCode: 'DK',
    clientName: 'Aerin Medical Inc',
    clientShortName: 'Aerin',
    dmsFlag: 'N',
  },
  {
    clientCode: 'CV',
    clientName: 'Aero US Inc. dba Aerogen',
    clientShortName: 'Aerogen',
    dmsFlag: 'Y',
  },
  {
    clientCode: 'DJ',
    clientName: 'Aesku Inc.',
    clientShortName: 'Aesku',
    dmsFlag: 'Y',
  },
  {
    clientCode: 'DY',
    clientName: 'Biogen',
    clientShortName: 'Biogen',
    dmsFlag: 'N',
  },
  {
    clientCode: 'DH',
    clientName: 'Biomodal',
    clientShortName: 'Biomodal',
    dmsFlag: 'N',
  },
  {
    clientCode: 'EG',
    clientName: 'BIOTRONIK, Inc.',
    clientShortName: 'BIOTRONIK',
    dmsFlag: 'N',
  },
  {
    clientCode: 'EB',
    clientName: 'Candesant Biomedical, Inc.',
    clientShortName: 'Candesant',
    dmsFlag: 'N',
  },
  {
    clientCode: 'CO',
    clientName: 'Carwin Pharmaceuticals',
    clientShortName: 'Carwin',
    dmsFlag: 'Y',
  },
  {
    clientCode: 'CJ',
    clientName: 'Catalent Pharma Solutions, LLC',
    clientShortName: 'Catalent',
    dmsFlag: 'N',
  },
  {
    clientCode: 'AB',
    clientName: 'ChiRhoClin, Inc.',
    clientShortName: 'ChiRhoClin',
    dmsFlag: 'Y',
  },
  {
    clientCode: 'AE',
    clientName: 'ParaPRO, LLC',
    clientShortName: 'Cipher',
    dmsFlag: 'Y',
  },
  {
    clientCode: 'DL',
    clientName: 'Civica, Inc.',
    clientShortName: 'Civica',
    dmsFlag: 'N',
  },
  {
    clientCode: 'BZ',
    clientName: 'CMP Pharma, Inc.',
    clientShortName: 'CMP',
    dmsFlag: 'N',
  },
  {
    clientCode: 'DP',
    clientName: 'Devatis Inc.',
    clientShortName: 'Devatis',
    dmsFlag: 'Y',
  },
  {
    clientCode: 'FB',
    clientName: 'DS3 RX LLC',
    clientShortName: 'DS3',
    dmsFlag: 'Y',
  },
  {
    clientCode: 'DC',
    clientName: 'E5 Pharma',
    clientShortName: 'E5 Pharma',
    dmsFlag: 'Y',
  },
  {
    clientCode: 'BS',
    clientName: 'Eli Lilly - Global Packaging',
    clientShortName: 'Eli Lilly - Global Packaging',
    dmsFlag: 'N',
  },
  {
    clientCode: 'AR',
    clientName: 'Eli Lilly - External Manufacturing',
    clientShortName: 'Eli Lilly - Idm',
    dmsFlag: 'N',
  },
  {
    clientCode: 'EL',
    clientName: 'Eli Lilly - Nalo',
    clientShortName: 'Eli Lilly - Nalo',
    dmsFlag: 'N',
  },
  {
    clientCode: 'AS',
    clientName: 'Eli Lilly - Parenteral',
    clientShortName: 'Eli Lilly - Parenteral',
    dmsFlag: 'N',
  },
  {
    clientCode: 'CC',
    clientName: 'Eli Lilly - R5 Pack Project',
    clientShortName: 'Eli Lilly - R5',
    dmsFlag: 'N',
  },
  {
    clientCode: 'CE',
    clientName: 'Eli Lilly - R6 Wet Project',
    clientShortName: 'Eli Lilly - R6',
    dmsFlag: 'N',
  },
  {
    clientCode: 'CK',
    clientName: 'Eli Lilly Global Robotics Program',
    clientShortName: 'Eli Lilly Global Robotics',
    dmsFlag: 'N',
  },
  {
    clientCode: 'BF',
    clientName: 'Eli Lilly - LRL',
    clientShortName: 'Eli Lilly LRL',
    dmsFlag: 'N',
  },
  {
    clientCode: 'CR',
    clientName: 'Eli Lilly - RTP Project',
    clientShortName: 'Eli Lilly RTP Project',
    dmsFlag: 'N',
  },
  {
    clientCode: 'DEFAULT',
    clientName: 'FLA State',
    clientShortName: 'FLA State',
    dmsFlag: 'N',
  },
  {
    clientCode: 'EO',
    clientName: 'The Flume Catheter Company, Inc',
    clientShortName: 'Flume',
    dmsFlag: 'Y',
  },
  {
    clientCode: 'DW',
    clientName: 'Hubly Surgical',
    clientShortName: 'Hubly',
    dmsFlag: 'Y',
  },
  {
    clientCode: 'CW',
    clientName: 'i3 Pharmaceuticals, LLC',
    clientShortName: 'i3 Pharma',
    dmsFlag: 'Y',
  },
  {
    clientCode: 'EA',
    clientName: 'Indiana Department of Health',
    clientShortName: 'IDOH',
    dmsFlag: 'N',
  },
  {
    clientCode: 'BB',
    clientName: 'Jaguar Animal Health, Inc.',
    clientShortName: 'Jaguar Animal Health',
    dmsFlag: 'Y',
  },
  {
    clientCode: 'EV',
    clientName: 'Kardion, Inc.',
    clientShortName: 'Kardion',
    dmsFlag: 'N',
  },
  {
    clientCode: 'DA',
    clientName: 'Kartha Pharmaceuticals, INC',
    clientShortName: 'Kartha',
    dmsFlag: 'Y',
  },
  {
    clientCode: 'BH',
    clientName: 'Kindred Biosciences, Inc.',
    clientShortName: 'Kindred Bio',
    dmsFlag: 'Y',
  },
  {
    clientCode: 'DS',
    clientName: 'Lilly Wet Line B3',
    clientShortName: 'Lilly B3',
    dmsFlag: 'N',
  },
  {
    clientCode: 'DO',
    clientName: 'Lilly CT K401',
    clientShortName: 'Lilly CT',
    dmsFlag: 'N',
  },
  {
    clientCode: 'DV',
    clientName: 'Lilly GPL Asset Delivery Concord',
    clientShortName: 'Lilly GPL',
    dmsFlag: 'N',
  },
  {
    clientCode: 'DT',
    clientName: 'Lilly GPR Asset Delivery',
    clientShortName: 'Lilly GPR',
    dmsFlag: 'N',
  },
  {
    clientCode: 'DQ',
    clientName: 'Lilly Wet Line R5C',
    clientShortName: 'Lilly R5C',
    dmsFlag: 'N',
  },
  {
    clientCode: 'LS',
    clientName: 'LifeScience Logistics, LLC.',
    clientShortName: 'LSL',
    dmsFlag: 'N',
  },
  {
    clientCode: 'CL',
    clientName: 'Marnel Pharmaceuticals LLC',
    clientShortName: 'Marnel',
    dmsFlag: 'N',
  },
  {
    clientCode: 'FG',
    clientName: 'Merck',
    clientShortName: 'Merck',
    dmsFlag: 'N',
  },
  {
    clientCode: 'DF',
    clientName: 'NanoTemper Technologies, Inc.',
    clientShortName: 'NanoTemper',
    dmsFlag: 'N',
  },
  {
    clientCode: 'AT',
    clientName: 'Natco Pharma USA LLC',
    clientShortName: 'Natco Pharma',
    dmsFlag: 'Y',
  },
  {
    clientCode: 'CD',
    clientName: 'Nationwide Pharmaceutical, LLC.',
    clientShortName: 'Nationwide',
    dmsFlag: 'N',
  },
  {
    clientCode: 'DE',
    clientName: 'Neurent Medical Inc',
    clientShortName: 'Neurent',
    dmsFlag: 'Y',
  },
  {
    clientCode: 'DN',
    clientName: 'Neuromod USA Inc.',
    clientShortName: 'Neuromod',
    dmsFlag: 'Y',
  },
  {
    clientCode: 'AG',
    clientName: 'Nivagen Pharmaceuticals, Inc',
    clientShortName: 'Nivagen',
    dmsFlag: 'Y',
  },
  {
    clientCode: 'BC',
    clientName: 'NovaBay Pharmaceuticals, Inc',
    clientShortName: 'NovaBay',
    dmsFlag: 'Y',
  },
  {
    clientCode: 'EN',
    clientName: 'Novo Nordisk Pharmaceuticals',
    clientShortName: 'Novo Nordisk',
    dmsFlag: 'N',
  },
  {
    clientCode: 'CH',
    clientName: 'Novos Patient Solutions LLC',
    clientShortName: 'Novos',
    dmsFlag: 'Y',
  },
  {
    clientCode: 'BO',
    clientName: 'NX Development',
    clientShortName: 'NX Development',
    dmsFlag: 'Y',
  },
  {
    clientCode: 'CT',
    clientName: 'Oakrum Pharma, LLC',
    clientShortName: 'Oakrum',
    dmsFlag: 'Y',
  },
  {
    clientCode: 'BW',
    clientName: 'Olympus',
    clientShortName: 'Olympus',
    dmsFlag: 'Y',
  },
  {
    clientCode: 'BP',
    clientName: 'Partner Therapeutics',
    clientShortName: 'Partner Therapeutics',
    dmsFlag: 'N',
  },
  {
    clientCode: 'DX',
    clientName: 'Perfuze Ltd.',
    clientShortName: 'Perfuze',
    dmsFlag: 'Y',
  },
  {
    clientCode: 'DG',
    clientName: 'Pfanstiehl, Inc.',
    clientShortName: 'Pfanstiehl',
    dmsFlag: 'N',
  },
  {
    clientCode: 'DI',
    clientName: 'Pristine Surgical LLC',
    clientShortName: 'Pristine',
    dmsFlag: 'Y',
  },
  {
    clientCode: 'FA',
    clientName: 'ProKidney LLC',
    clientShortName: 'ProKidney',
    dmsFlag: 'N',
  },
  {
    clientCode: 'BK',
    clientName: 'Prollenium Medical Technologies Inc.',
    clientShortName: 'Prollenium',
    dmsFlag: 'N',
  },
  {
    clientCode: 'CN',
    clientName: 'Qorvo Biotechnologies, LLC',
    clientShortName: 'Qorvo',
    dmsFlag: 'Y',
  },
  {
    clientCode: 'ED',
    clientName: 'Renosis',
    clientShortName: 'Renosis',
    dmsFlag: 'N',
  },
  {
    clientCode: '07',
    clientName: 'S/D Supply',
    clientShortName: 'S/D Supply',
    dmsFlag: 'N',
  },
  {
    clientCode: 'BY',
    clientName: 'Scope Health Inc',
    clientShortName: 'Scope',
    dmsFlag: 'Y',
  },
  {
    clientCode: 'AZ',
    clientName: 'Spectral Medical Inc.',
    clientShortName: 'Spectral',
    dmsFlag: 'N',
  },
  {
    clientCode: 'ES',
    clientName: 'Spectrum Vascular',
    clientShortName: 'Spectrum',
    dmsFlag: 'Y',
  },
  {
    clientCode: 'AP',
    clientName: 'Stratpharma Inc.',
    clientShortName: 'Stratpharma',
    dmsFlag: 'N',
  },
  {
    clientCode: 'CU',
    clientName: 'Talis Biomedical',
    clientShortName: 'Talis Bio',
    dmsFlag: 'Y',
  },
  {
    clientCode: 'FD',
    clientName: 'TecTraum, Inc.',
    clientShortName: 'TecTram',
    dmsFlag: 'Y',
  },
  {
    clientCode: 'EE',
    clientName: 'Tempus Labs, Inc',
    clientShortName: 'Tempus',
    dmsFlag: 'N',
  },
  {
    clientCode: 'CZ',
    clientName: 'Tricida',
    clientShortName: 'Tricida',
    dmsFlag: 'Y',
  },
  {
    clientCode: 'CX',
    clientName: 'Tripoint Therapeutics, LLC',
    clientShortName: 'Tripoint',
    dmsFlag: 'Y',
  },
  {
    clientCode: 'ET',
    clientName: 'TSC Life Inc.',
    clientShortName: 'TSC',
    dmsFlag: 'N',
  },
  {
    clientCode: 'FC',
    clientName: 'Union Agener',
    clientShortName: 'Union Agener',
    dmsFlag: 'N',
  },
  {
    clientCode: 'FE',
    clientName: 'United Therapeutics',
    clientShortName: 'United',
    dmsFlag: 'Y',
  },
  {
    clientCode: 'BX',
    clientName: 'ZO Skin Health',
    clientShortName: 'ZO Skin',
    dmsFlag: 'N',
  },
])
